<template>
  <div class="upload-image-wrapper">
    <Upload
      ref="upload"
      :show-upload-list="false"
      :format="format"
      :max-size="maxSize"
      :multiple="multiple"
      :before-upload="handleBeforeUpload"
      :disabled="disabled"
      action="/">
        <slot name="content" class="fullwidth"></slot>
    </Upload>
  </div>
</template>
<script>
import { convertFileToBase64, validateExtension } from '@/utils/helper'
export default {
  props: {
    format: {
      type: Array,
      default: () => ['jpg', 'jpeg', 'png']
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxSize: {
      type: Number,
      default: 2048
    }
  },
  methods: {
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select ' + this.format.join(', ') + '.'
      })
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: 'Exceeding file size limit',
        desc: 'File  ' + file.name + ' is too large, no more than ' + this.maxSize / 1024 + ' mb.'
      })
    },
    async handleBeforeUpload (file) {
      const { name } = file
      if (!validateExtension(name, this.format)) {
        this.handleFormatError(file)
      } else if (file.size * 0.001 > this.maxSize) {
        this.handleMaxSize(file)
      } else {
        const fileBase64 = await convertFileToBase64(file).then(data => data)
        this.$emit('upload', fileBase64, name)
      }
    }
  }
}
</script>
